<mat-card>
  <mat-card-header>
    <mat-card-title>Instruction Summary</mat-card-title>
    <mat-card-subtitle>Review your Instruction before saving.</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-list>
      <!-- Definition -->
      <div class="section-title">Definition</div>
      <div class="item">
        <span class="label">Name:</span>
        <span>{{ instruction.details.name }}</span>
      </div>
      <div class="item">
        <span class="label">Description:</span>
        @if (instruction.details.description && instruction.details.description!.length > 0) {
          <span>{{ instruction.details.description }}</span>
        } @else {
          <span>No description added</span>
        }
      </div>

      <!-- Keywords -->
      <div class="item">
        <span class="label">Keywords:</span>
        @if (instruction.details.keywords && instruction.details.keywords!.length > 0) {
          <div class="chips-container">
            <mat-chip-set>
              @for (keyword of instruction.details.keywords; track keyword) {
                <mat-chip>{{ keyword }}</mat-chip>
              }
            </mat-chip-set>
          </div>
        } @else {
          <span>No keywords added</span>
        }
      </div>


      <!-- AI Configuration -->
      <div class="section-title">AI Configuration</div>
      <div class="item">
        <span class="label">Temperature:</span>
        <span>{{ instruction.details.temperature }}</span>
      </div>

      <div class="item">
        <span class="label">Top P:</span>
        <span>{{ instruction.details.topP }}</span>
      </div>

      @if (instruction.details.model.model) {
        <div class="item">
          <span class="label">Model:</span>
          <span>{{ instruction.details.model.model }}</span>
        </div>

      }

      <!-- Type-specific fields -->
      <div class="section-title">Types</div>
      <div class="item">
        <span class="label">Type:</span>
        <span>{{ instruction.details.type }}</span>
      </div>
      <!-- Prompt -->
      <div class="item">
        <span class="label">Prompt:</span>
        @if (instruction.details.prompt && instruction.details.prompt!.length > 0) {
          <span>{{ instruction.details.prompt }}</span>
        } @else {
          <span>No prompt added</span>
        }
      </div>
      @if (instruction.details.type === 'Agent' || instruction.details.type === 'File Upload') {
        <div class="item">
          <span class="label">Agent:</span>
          <span>{{ instructionAgentName }}</span>
        </div>
      }
      <!-- Sensitivity Labels -->
      @if (slEnabled()) {
        <div class="section-title">Sensitivity Labels</div>
        @if (instruction.details.sensitivityLabels && instruction.details.sensitivityLabels.length > 0) {
          @for (label of instruction.details.sensitivityLabels; track label) {
            <div class="item">
              <span>{{ agentService.getSensitivityLabelString(label) }}</span>
            </div>
          }
        }
      }

      @if (instruction.details.type === 'File Upload') {
        <div class="item">
          <span class="label">File Upload Label:</span>
          @if (instruction.details.fileUploadLabel && instruction.details.fileUploadLabel!.length > 0) {
            <span>{{ instruction.details.fileUploadLabel }}</span>
          } @else {
            <span>No file upload label added</span>
          }
        </div>
      }

      @if (instruction.details.type === 'Collect Information') {
        <div class="item">
          <span class="label">Information Collection Label:</span>
          @if (instruction.details.collectInformationLabel && instruction.details.collectInformationLabel!.length > 0) {
            <span>{{ instruction.details.collectInformationLabel }}</span>
          } @else {
            <span>No collect information label added</span>
          }
        </div>

      }

      <!-- Administration -->
      <div class="section-title">Administration</div>
      <div class="item">
        <span class="label">Enabled:</span>
        <span>{{ instruction.details.isEnabled ? 'Yes' : 'No' }}</span>
      </div>

      <div class="item">
        <span class="label">Universal:</span>
        <span>{{ instruction.details.isUniversal ? 'Yes' : 'No' }}</span>
      </div>


      @if (showInstructionSecuritySummary) {
        <!-- Security -->
        <div class="section-title">Security</div>

        <!-- Owners -->
        <div class="list-section-title">Owners</div>
        @if (instruction.details.owners && instruction.details.owners.length > 0) {
          <kendo-listview [data]="instruction.details.owners" class="owners-listview">
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <div>
                <span>{{ dataItem.name }} ({{ dataItem.userId }})</span>
              </div>
            </ng-template>
          </kendo-listview>
        } @else {
          <div class="item">
            <span>No owners defined</span>
          </div>
        }

        <!-- Users -->
        <div class="list-section-title">Users</div>
        @if (instruction.details.users && instruction.details.users.length > 0) {
          <kendo-listview [data]="instruction.details.users" class="users-listview">
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <div>
                <span>{{ dataItem.name }} ({{ dataItem.userId }})</span>
              </div>
            </ng-template>
          </kendo-listview>
        } @else {
          <div class="item">
            <span>No users defined</span>
          </div>
        }

        <!-- Groups -->
        <div class="list-section-title">Groups</div>
        @if (instruction.details.groups && instruction.details.groups.length > 0) {
          <kendo-listview [data]="instruction.details.groups" class="groups-listview">
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <div>
                <span>{{ dataItem.displayName }}</span>
              </div>
            </ng-template>
          </kendo-listview>
        } @else {
          <div class="item">
            <span>No groups defined</span>
          </div>
        }
      }
    </mat-list>
  </mat-card-content>
</mat-card>
